module.exports = __webpack_public_path__ + "img/BOR_header-bg.2da40482.jpg";